import React, { useEffect, useState } from "react";
import { Card, CardContent, CardMedia, Typography, CircularProgress, Box } from "@mui/material";


import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { fetchEntrypointData } from "../apiservices/ApiService";

const Card114EntryPoint = () => {
  const [data, setData] = useState([]); // Store filtered data
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const navigate = useNavigate(); // Navigation hook

  const location = useLocation();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchEntrypointData();

        // Filter specific cards based on cardType
        const filteredData = result.entryData.filter((item) =>
          ["YearReview", "My Profile", "Support", "settings", "goqii-cash"].includes(item.iconType) // Add specific cardType values you want to include
        );

        setData(filteredData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCardClick = (iconType) => {

     // Extract and log all query parameters
     const queryParams = new URLSearchParams(location.search);
  
     // Convert query parameters to an object (optional)
     const paramsObject = {};
     queryParams.forEach((value, key) => {
       paramsObject[key] = value;
     });
     // Navigate to specific pages based on iconType
     if (iconType === "YearReview") {
      navigate("/year-review" + `?${queryParams}`);
    } else if (iconType === "My Profile") {
      navigate("/fsn37" + `?${queryParams}`);
    } else if (iconType === "Support") {
      navigate("/fsn170" + `?${queryParams}`);
    } else if (iconType === "settings") {
      navigate("/fsn44" + `?${queryParams}`);
    } else if (iconType === "goqii-cash") {
      navigate("/goqii-cash" + `?${queryParams}`);
    } else {
      console.warn("Unhandled iconType:", iconType);
    }
   
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "150px" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "150px" }}>
        <Typography color="error">Error: {error}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        overflowX: "auto", // Enables horizontal scrolling
        gap: "10px", // Matches the gap in Card64
        justifyContent: "flex-start", // Aligns cards to the start
        padding: "10px", // Consistent padding like Card64
        backgroundColor: "#f3f3f3", // Matches Card64 background
        borderRadius: "8px", // Smooth corners like in Card64
      }}
    >
      {data.map((entry, index) => (
        <Card
          key={index}
          onClick={() => handleCardClick(entry.iconType)} // Use the click handler
          sx={{
            flex: "0 0 auto", // Prevents cards from shrinking
            width: 80, // Matches card size
            height: 80, // Matches card size
            cursor: "pointer",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center", // Centers content inside the card
            padding: 1,
            backgroundColor: "#ffffff",
            borderRadius: "8px", // Matches Card64's habit card styling
            border: "1px solid #e0e0e0", // Light border for separation
          }}
        >
          <CardMedia
            component="img"
            image={entry.iconUrl}
            alt={entry.keyword || "Icon"}
            sx={{
              width: 80, // Image size
              height: 80,
              padding: "8px",
              objectFit: "contain", // Prevents distortion
              marginBottom: "10px", // Adds spacing below the image
            }}
          />
        </Card>
      ))}
    </Box>
  );
};

export default Card114EntryPoint;